<template>
  <div class="user_guide">
    <h2>使用指南</h2>
    <div class="list">
      <div class="item">
        <div class="item_left van-multi-ellipsis--l2">
          一篇文章教你引流拓客，提升获客效率
        </div>
        <div class="item_right">
          <img src="../../assets/images/banner2.jpg" />
        </div>
      </div>
      <div class="item">
        <div class="item_left van-multi-ellipsis--l2">
          一篇文章教你引流拓客，提升获客效率
        </div>
        <div class="item_right">
          <img src="../../assets/images/banner2.jpg" />
        </div>
      </div>
      <div class="item">
        <div class="item_left van-multi-ellipsis--l2">
          一篇文章教你引流拓客，提升获客效率
        </div>
        <div class="item_right">
          <img src="../../assets/images/banner2.jpg" />
        </div>
      </div>
      <div class="item">
        <div class="item_left van-multi-ellipsis--l2">
          一篇文章教你引流拓客，提升获客效率
        </div>
        <div class="item_right">
          <img src="../../assets/images/banner2.jpg" />
        </div>
      </div>
      <div class="item">
        <div class="item_left van-multi-ellipsis--l2">
          一篇文章教你引流拓客，提升获客效率一篇文章教你引流拓客，提升获客效率一篇文章教你引流拓客，提升获客效率一篇文章教你引流拓客，提升获客效率
        </div>
        <div class="item_right">
          <img src="../../assets/images/banner2.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyGuide"
};
</script>

<style lang="scss" scoped>
.user_guide {
  background: #ffffff;
  h2 {
    line-height: 1rem;
    padding: 0 0.3rem;
    font-size: 0.4rem;
  }
  .list {
    padding: 0 0 0 0.3rem;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 0.01rem solid #e9e9e9;
      padding: 0.2rem 0;
      .item_left {
        flex: 1;
        padding-right: 0.2rem;
        letter-spacing: 0.02rem;
      }
      .item_right {
        width: 2rem;
        height: 1rem;
        font-size: 0;
        padding-right: 0.3rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
